import * as solid from './v7/solid'
import * as regular from './v7/regular'
import * as light from './v7/light'
import * as thin from './v7/thin'
import * as duotone from './v7/duotone'
import * as duotoneRegular from './v7/duotoneRegular'
import * as duotoneLight from './v7/duotoneLight'
import * as duotoneThin from './v7/duotoneThin'
import * as brands from './v7/brands'
import * as sharpSolid from './v7/sharpSolid'
import * as sharpRegular from './v7/sharpRegular'
import * as sharpLight from './v7/sharpLight'
import * as sharpThin from './v7/sharpThin'
import * as sharpDuotoneSolid from './v7/sharpDuotoneSolid'
import * as sharpDuotoneRegular from './v7/sharpDuotoneRegular'
import * as sharpDuotoneLight from './v7/sharpDuotoneLight'
import * as sharpDuotoneThin from './v7/sharpDuotoneThin'

import * as custom from './custom'

export default {
  solid,
  regular,
  light,
  thin,
  duotone,
  duotoneLight,
  duotoneThin,
  duotoneRegular,
  brands,
  sharpSolid,
  sharpRegular,
  sharpLight,
  sharpThin,
  sharpDuotoneSolid,
  sharpDuotoneRegular,
  sharpDuotoneLight,
  sharpDuotoneThin,
  custom
}
